import { Component, Input, OnInit } from '@angular/core';
import { gungComparatorHelper } from 'gung-common';
import { Customer } from '../../models';
import { GungCustomerAddress, GungCustomerAddressService } from '../../services/gung-customer-address.service';

@Component({
  selector: 'lib-customer-details-info-tab',
  templateUrl: './customer-details-info-tab.component.html',
  styleUrl: './customer-details-info-tab.component.scss',
  standalone: false
})
export class CustomerDetailsInfoTabComponent implements OnInit {
  @Input() customer: Customer;
  favouriteAddresses: GungCustomerAddress[] = [];
  favouriteAddressIds: Set<string> = new Set();

  constructor(public gungCustomerAddressService: GungCustomerAddressService) {}

  get sortedDeliveryAddresses() {
    if (!this.customer?.extra?.gme?.deliveryAddresses) {
      return [];
    }

    const addresses = [...this.customer.extra.gme.deliveryAddresses];

    if (this.gungCustomerAddressService.enableFavouriteDeliveryAddresses) {
      return addresses.sort((a, b) => {
        const aKey = this.getAddressKey(a);
        const bKey = this.getAddressKey(b);
        const aIsFav = this.favouriteAddressIds.has(aKey) ? 1 : 0;
        const bIsFav = this.favouriteAddressIds.has(bKey) ? 1 : 0;
        return gungComparatorHelper(aIsFav,bIsFav, -1);
      });
    }

    return addresses;
  }

  ngOnInit(): void {
    if (this.gungCustomerAddressService.enableFavouriteDeliveryAddresses) {
      this.gungCustomerAddressService.getFavouriteCustomerAddresses(this.customer.id).subscribe(addresses => {
        this.favouriteAddresses = addresses;
        this.favouriteAddressIds = new Set(addresses.map(addr => addr.deliveryAddressId));
      });
    }
  }

  toggleFavourite(address: GungCustomerAddress): void {
    const addressKey = this.getAddressKey(address);
    const isFav = this.favouriteAddressIds.has(addressKey);

    if (isFav) {
      const favToRemove = this.favouriteAddresses.find(a => a.deliveryAddressId === addressKey);
      this.gungCustomerAddressService
        .deleteFavouriteCustomerAddress(this.customer.id, favToRemove.id)
        .subscribe(() => {
          this.favouriteAddresses = this.favouriteAddresses.filter(a => a.id !== address.id);
          this.favouriteAddressIds.delete(this.getAddressKey(address));
        });
    } else {
      this.gungCustomerAddressService
        .addFavouriteCustomerAddress(this.customer.id, addressKey)
        .subscribe(fav => {
          this.favouriteAddresses = [...this.favouriteAddresses, fav];
          this.favouriteAddressIds.add(this.getAddressKey(address));
        });
    }
  }

  private getAddressKey(address): string {
    return `${address.address1}${address.address2}${address.city}${address.countryCode}${address.name}${address.zipCode}`;
  }
}
